module.exports = __webpack_public_path__ + "static/media/survilance_cam_specialisatoin.67583808.gif";